module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#711ae4",
      "margin-top": "-5em"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "2em",
      "margin-left": "3em",
      "margin-top": "10em",
      "text-align": "center"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "text-transform": "uppercase",
      "letter-spacing": "7px"
    }
  }, [_vm._v(_vm._s(_vm.app_name))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ececec"
    }
  }, [_vm._v("Smart Shopping")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/ms-guy.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ef5f3c"}!./src/pages/Home/template.html
// module id = 593
// module chunks = 0